// Objective: Define the service to get the loan leads
import HttpClient from '../http/HttpClient';
import { LEAD_SERVICE_HOST, LEAD_API_PREFIX } from '../constants/RestConstants';


export async function getInsights(filterObj: Object = {}) {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/all/dashboard`,
  }); 
  return response;
}

export async function getMonthlyOutstandingReport() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-outstanding`,
  }); 
  return response;
}

export async function sendMonthlyOutstandingReportEmail() {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/monthly-outstanding/send-email`,
    data: {},
  }); 
  return response;
}

export async function getLendingClassification() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/lending-classification`,
  }); 
  return response;
}

export async function getCurrentYearCashflow() {
  const response = await HttpClient.GET({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/current-year-cashflow`,
  }); 
  return response;
}

export async function sendAccountStatementEmail() {
  const response = await HttpClient.POST({
    BASE_URL: LEAD_SERVICE_HOST,
    END_POINT: `${LEAD_API_PREFIX}/reports/account-statement/send-email`,
    data: {},
  }); 
  return response;
}